<template>
  <div class="page-listings">
    <div id="pag" style="position: absolute; top: 0;"></div>
    <banner-1 title="FreeSpan Opportunity Registration" desc="Please fill out this form to submit a new Opportunity Registration. The requested information is imperative to project strategy and will help Spacesaver better support you."/>

    <section id="ScrollTarget" class="py-5 bs-shadow mobile-top">
      
      <div data-v-5a90ec03 class="container">

        <!--
        {{productTypesSelected.join(', ')}}
        -->
        

       <!--  
        <h1 class="lh1">Interterritorial Projects</h1>
        -->
        
  
        
    

        <transition
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          :duration="500"
          mode="out-in"
          appear
        >
        <div>
          <div v-if="step == 1" class="step1" key="step1">
            <div class="listing">
          
              <h5>
                <span class="teal"> Account Information</span>
              </h5>
              <hr />
              <div class="row">
                <div class="col-xs-12 col-md-6 col-12">

                  <div class="form-group">
                    <label for="exampleInputEmail1"
                      >* Area Contractor <small v-if="check1 && !acFilter" class="orange">This field is required.</small></label>
                    
                    <select
                  v-if="loading && acFilter == null"
                  disabled
                  class="form-control"
                  id="exampleFormControlSelect1"
                  style="padding: 0.375rem 0.75rem!important;"
                  v-model="acFilter"
                >
                  <option :value="null" selected class="all-contractors">
                    Area Contractor
                  </option>
                </select>

                <select
                  v-else
                  class="form-control"
                  id="exampleFormControlSelect1"
                  style="padding: 0.375rem 0.75rem!important;"
                  v-model="acFilter"
                  v-on:change="getTerritories()"
                  :disabled="loading"
                >
                  <option :value="null" selected class="all-contractors">
                    Area Contractor
                  </option>
                  <option
                    v-for="ac in acs"
                    @click="setACFilterName(ac.acName)"
                    :key="ac.acid"
                    :value="ac"
                  >
                    {{ " " + ac.acName + " (" + ac.acid + ")" }}
                  </option>
                </select>
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1"
                      >* Sales Rep  <small v-if="check1 && !repFilter" class="orange">This field is required.</small></label>
                    
                    <select
                  class="form-control"
                  id="exampleFormControlSelect1"
                  style="padding: 0.375rem 0.75rem!important;"
                  v-model="repFilter"
                >
                  <option :value="null" selected class="all-contractors">
                    Sales Rep
                  </option>
                   <option
                    v-for="rep in filteredReps"
                    :key="rep.fullName"
                    :value="rep.fullName"
                  >
                    {{ rep.fullName }}
                  </option>
                </select>
                </div>



             

           
            
                
           
               

              
          
        
         
                </div>
                <div class="col-xs-12 col-md-6 col-12">
                          <div class="form-group">
                  <label for="exampleFormControlSelect1">* Project Market <small v-if="check1 && !MarketSelection" class="orange">This field is required.</small></label>
                  <select
                    v-model="MarketSelection"
                    class="form-control"
                    id="exampleFormControlSelect1"
                    style="padding: 0.375rem 0.75rem!important;"
                  >
                    <option
                      disabled
                      v-bind:value="null"
                      class="all-contractors"
                    >
                      Select a market
                    </option>

                    <option value="Agriculture">Agriculture</option>
                    <option value="Business">Business</option>
                    <option value="Education">Education</option>
                    <option value="Education K-12">Education K-12</option>
                    <option value="Government">Government</option>
                    <option value="Healthcare">Healthcare</option>
                    <option value="Library">Library</option>
                    <option value="Military">Military</option>
                    <option value="Museum">Museum</option>
                    <option value="Public Safety">Public Safety</option>             
                    <option value="Unknown">Unknown</option>
                  </select>
                </div>
                       <div class="form-group">
                    <label for="exampleInputEmail1"
                      >* Opportunity Name / Department <small v-if="check1 && !projectName" class="orange">This field is required.</small></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Project Name"
                      placeholder="Department where install is taking place, product(s) being installed"
                      v-model="projectName"
                    />
                  </div>

         
                  
       

                            
                </div>
              </div>
                  <h5>
                <span class="teal"> Customer Information</span>
              </h5>
              <hr />
           
  <div class="row" style="padding-top: 10px;">
                <div class="col-xs-12 col-md-6 col-12">
                <div class="form-group">
                  <label for="exampleInputEmail1">* End User/Customer Name <small v-if="check1 && !AccountName.length" class="orange">This field is required.</small></label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Account Name"
                    placeholder="Legal Company Name"
                    v-model="AccountName"
                  />
                </div> 
                <div class="form-group">
                    <label for="exampleFormControlTextarea1">* End User/Customer Street Address <small v-if="check2 && !projectAddress.length" class="orange">This field is required.</small></label>
                    <textarea
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      rows="1"
                      placeholder="Enter Street Address..."
                      v-model="projectAddress"
                      required
                    ></textarea>
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">* End User/Customer City <small v-if="check2 && !projectCity.length" class="orange">This field is required.</small></label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="City"
                      placeholder="Enter City"
                      v-model="projectCity"
                      required
                    />
                  </div>
                   <div class="form-group">
                    <label for="exampleInputEmail1"
                      >* End User/Customer State <small v-if="check2 && !projectState.length" class="orange">This field is required.</small>
                      </label
                    >
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="State"
                      placeholder="Enter State"
                      :maxlength="statemax"
                      required
                      :value="projectState.toUpperCase()"
                      @input="projectState = $event.target.value.toUpperCase()"
                    />
                  </div>
                
                  </div>
                    <div class="col-xs-12 col-md-6 col-12">
                        <div class="form-group">
                    <label for="exampleInputEmail1">* End User/Customer Zip Code <small v-if="check2 && !projectZip.length" class="orange">This field is required.</small></label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Zip Code"
                      placeholder="Enter Zip Code"
                      v-model="projectZip"
                      required
                    />
                  </div>
                             <div class="form-group">
                    <label for="exampleInputEmail1"
                      >* Contact Name <small v-if="check2 && !contactName.length" class="orange">This field is required.</small><small v-if="check2 && (!this.checkFirst ||
                      !this.checkLast)" class="orange"> Please enter a first and last name</small></label
                    >
                   
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Project Name"
                      placeholder="Enter Project Contact First and Last Name"
                      v-model="contactName"
                    />
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">* Contact Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Phone"
                      placeholder="Enter Contact Phone"
                      v-model="contactPhone"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputEmail1">* Contact Email</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Email"
                      placeholder="Enter Contact Email"
                      v-model="contactEmail"
                      required
                    />
                  </div>
                  </div>
                  </div>

         <h5>
                <span class="teal"> Architect Information</span>
              </h5>
   <hr />
  <div class="row" style="padding-top: 10px;">
      <div class="col-xs-12 col-md-6 col-12">
<div class="form-group" style="margin-bottom: 15px;">
  <label style="margin-bottom: 20px; display: block;">
    Are you working with an architect? <small v-if="check1 && workWithArchitect === null" class="orange">This field is required.</small>
  </label>

  <div class="custom-radio-group">
     <label class="custom-radio">
      <input 
        type="radio" 
        name="workWithArchitect" 
        id="architect-no" 
        value="false" 
        v-model="workWithArchitect"
      >
      <span class="radio-dot"></span>
      No
    </label>
    <label class="custom-radio">
      <input 
        type="radio" 
        name="workWithArchitect" 
        id="architect-yes" 
        value="true" 
        v-model="workWithArchitect"
      >
      <span class="radio-dot"></span>
      Yes
    </label>

   
  </div>
</div>
    <span v-if="workWithArchitect == 'true'">

      
        
      
      
       

      
     <div class="form-group">
                  <label for="exampleInputEmail1">Architecture Firm <small v-if="check1 && !AccountName.length" class="orange">This field is required.</small></label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Account Name"
                    placeholder="Legal Company Name"
                    v-model="ArchitectureFirm"
                  />
                </div> 
                <div class="form-group">
                    <label for="exampleFormControlTextarea1">Architecture Firm Street Address <small v-if="check2 && !projectAddress.length" class="orange">This field is required.</small></label>
                    <textarea
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      rows="1"
                      placeholder="Enter Street Address..."
                      v-model="ArchFirmStreetAddress"
                      required
                    ></textarea>
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">Architecture Firm City <small v-if="check2 && !projectCity.length" class="orange">This field is required.</small></label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="City"
                      placeholder="Enter City"
                      v-model="ArchFirmCity"
                      required
                    />
                  </div>
      </span>
               
      </div>
      <div class="col-xs-12 col-md-6 col-12">
        <span v-if="workWithArchitect == 'true'">
            <div class="form-group architect-question">
                    <label for="exampleInputEmail1"
                      >Architecture Firm State <small v-if="check2 && !projectState.length" class="orange">This field is required.</small>
                      </label
                    >
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="State"
                      placeholder="Enter State"
                      :maxlength="statemax"
                      required
                      v-model="ArchFirmState"
                    />
                  </div>

                                         <div class="form-group">
                    <label for="exampleInputEmail1"
                      >Architect Name <small v-if="check2 && !contactName.length" class="orange">This field is required.</small><small v-if="check2 && (!this.checkFirst ||
                      !this.checkLast)" class="orange"> Please enter a first and last name</small></label
                    >
                   
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Project Name"
                      placeholder="Enter Architect First and Last Name"
                      v-model="ArchitectName"
                    />
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">Architect Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Phone"
                      placeholder="Enter Architect Phone"
                      v-model="ArchitectPhone"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputEmail1">Architect Email</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Email"
                      placeholder="Enter Architect Email"
                      v-model="ArchitectEmail"
                      required
                    />
                  </div>
                  </span>
      </div>
  </div>


                   <div class="row">
              <div class="col col-12">
                <div
                  class="
                    nav-btns
                    listing-header
                    d-flex
                    align-items-center
                    mt10
                    mb10
                    rounded
                    b-shadow
                  "
                >



          
                         <button
                      disabled
                      v-if="this.submitted"
                      class="mlauto"
                    >
                      Submitted
                      <i class="material-icons">keyboard_arrow_right</i>
                    </button>


                    <button
                      v-else
                      @click="validateAndShow"
                      class="mlauto"
                    >
                      Submit Opportunity
                      <i class="material-icons">keyboard_arrow_right</i>
                    </button>
    
                </div>
              </div>
            </div>
            </div>
          </div>

            <div v-if="step == 2" class="step1" key="step1">
            <div class="listing">    
             
              <div class="success-header">
                <img src="@/assets/img/success.svg"/>
                <h1>Awesome!</h1>
              </div>
              <div class="success-body">
                 <h4 style="color: #5a6877">
                The opportunity has been submitted!
                </h4>
              </div>
             
   
  
            </div>
          </div>
           <div v-if="step == 3" class="step1" key="step1">
            <div class="listing">    
             
              <div class="failure-header">
                <img src="@/assets/img/sad.svg"/>
                <h1>Sorry</h1>
              </div>
              <div class="failure-body">
                 <h4 style="color: #5a6877">
                There was an issue submitting your project.
                </h4>
                <p className="text-base">please reach out to <a className="text-teal-lightest dark:text-teal-lightest" href="mailto:hbare@spacesaver.com">hbare@spacesaver.com</a></p>
                <p className="text-base">or give us a call at <a className="text-teal-lightest dark:text-teal-lightest" href="tel:9205630611">920.563.0611</a></p>
                <p className="text-base">and we will get it fixed as soon as possible.</p>
              </div>
             
   
  
            </div>
          </div>
          </div>
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
// import Avatar from "vue-avatar";
// import Datepicker from "vuejs-datepicker";
import VueDatePicker from '@vuepic/vue-datepicker';
import Multiselect from "vue-multiselect";
import { HollowDotsSpinner } from "epic-spinners";
import Banner1 from "../components/Banners/banner1.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
// import "animate.css";




const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
  },
};

export default {
  name: "OpportunityRegistration",
  components: {
    AtomSpinner,
    // Avatar,
    // Datepicker,
    VueDatePicker,
    Multiselect,
    HollowDotsSpinner,
    Banner1,
    vSelect
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      server: import.meta.env.VITE_APP_SERVER_URL,
      // server: 'http://localhost:5002',
      backend: import.meta.env.VUE_APP_SERVER_URL,
      loading: true,
      projectName: "",
      customerName: "",
      MarketSelection:null,
      acFilter: null,
      repFilter: null,
      AccountName: "",
      projectAddress: "",
      projectCity: "",
      projectState: "",
      projectZip: "",
      bidDate:"",
      orderDate: "",
      shipDate: "",
      productTypes: [],
      statemax: 2,
      contactName: "", 
      contactPhone: "",
      contactEmail: "",
      ArchitectureFirm: "",
      ArchFirmStreetAddress: "",
      ArchFirmCity: "",
      ArchFirmState: "",
      ArchitectName: "",
      ArchitectPhone: "",
      ArchitectEmail: "",
      projectReason: "",
      step: 1,    
      userEmail: "",
      jobName: "",
      jobDesc: "",
      jobMarket: null,         
      leadSalesPerson: null,
      acList: null,
      State: "",
      County: "",
      AC: "",   
      acid: null,
      check1: false,
      submitted: false,
      salespeople: null,  
      workWithArchitect: false,     
    };
  },
  methods: {
    GetCompanyID() {
        let number = this.$store.state.user.ACId[0];
        this.acFilter = number;
    },
    removeTag(tagToBeRemove) {
      this.selected = this.selected.filter((tag) => tag.name !== tagToBeRemove.name);
      Bus.$emit('update:tags', this.selected);
    },

    async firstLoad() {
      this.loading = true;

      try {
        // 1. Active customer list
        const acResponse = await axios.get(
          `${this.ordermanageapi}/aclist?active=true`,
          auth
        );
        this.acs = acResponse.data;
        // this.GetCompanyID();

        // 2. Salespeople
        const spResponse = await axios.get(
          `${this.ordermanageapi}/salespeople`,
          auth
        );
        this.salespeople = spResponse.data.salesPeople;

        // 3. Product types
        const ptResponse = await axios.get(
          `${this.ordermanageapi}/options?type=ptypes`,
          auth
        );
        this.productTypes = ptResponse.data.productTypes;

        // 4. AC territories
        /*
        const territoryResponse = await axios.get(
          `${this.server}/api/v1/ac-territories`,
          auth
        );

        if (territoryResponse.status === 401) {
          console.warn("Not allowed to access ac-territories");
          // or: this.$router.push("/");  ← decide what you want
        } else {
          this.acList = territoryResponse.data.aCDistributors;
        }
        */

      } catch (error) {
        console.error("firstLoad failed:", error);

        if (error.response?.status === 401) {
          this.$router.push("/");
          return; // stop further execution
        }

    
      } finally {
        this.loading = false;
      }
    },
    submitProject(){
      let axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
        },
      };

      const fullName = this.contactName.split(' ');
 
      let postProjectData = {
          AreaContractorID: isNaN(Number(this.acFilter.acid)) ? null : Number(this.acFilter.acid),
          AreaContractorName: this.acFilter.acName,
          SalesRep: this.repFilter,
          ProjectMarket: this.MarketSelection,
          OpportunityNameDepartment: this.projectName,
          EndUserCustomerName: this.AccountName,
          EndUserStreetAddress: this.projectAddress,
          EndUserCity: this.projectCity,
          EndUserState: this.projectState,
          EndUserZipCode: this.projectZip,
          ContactName: this.contactName,
          ContactPhone: this.contactPhone,
          ContactEmail: this.contactEmail,
          ArchitectureFirm: this.ArchitectureFirm,
          ArchFirmStreetAddress: this.ArchFirmStreetAddress,
          ArchFirmCity: this.ArchFirmCity,
          ArchFirmState: this.ArchFirmState,
          ArchitectName: this.ArchitectName,
          ArchitectPhone: this.ArchitectPhone,
          ArchitectEmail: this.ArchitectEmail,
      };

      this.submitted = true;

      axios.post(`${this.server}/api/v1/freespan-opportunities`, postProjectData, axiosConfig).then(
        (response) => {
          console.log(response);
          if (response.data && response.data.message == "Opportunity created successfully") {
            this.$toast.success("Successfully created your opportunity submission!");
            this.step = this.step + 1;
            const el = document.getElementById("pag");
            el.scrollIntoView({ behavior: "smooth" });
          } else {
            // this.$router.push(`/interterritorial/${returnedID}`);
            this.$toast.error(
              "Sorry, there was an error submitting your opportunity"
            );
            this.step = this.step + 2;
            const el = document.getElementById("pag");
            el.scrollIntoView({ behavior: "smooth" });
          }
          
        },
        (error) => {
          console.log(error);
        }
      );

    },

    removeDollarSign: function () {
      if (this.SSCNetValue != null) {
        //console.log("removing");
        this.SSCNetValue = this.SSCNetValue.replace("$", "");
      }
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    setPage: function (idx) {
      document.activeElement.blur();
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      document
        .getElementById("ScrollTarget")
        .scrollIntoView({ behavior: "smooth" });
      this.step = idx;
    },
    validate() {
      const errors = [];

      if (this.acFilter === '' || this.acFilter == null || isNaN(Number(this.acFilter.acid))) {
        errors.push("Area Contractor is required.");
      }

      if(!this.repFilter){
        errors.push("Sales Rep is required.");
      }

      if(!this.MarketSelection){
        errors.push("Market is required.");
      }

      if(!this.projectName){
        errors.push("Opportunity Name / Department is required")
      }
      // ───────────────────────────────────────────────
      // Customer information
      // ───────────────────────────────────────────────
      if (!String(this.AccountName ?? '').trim()) {
        errors.push("End User/Customer Name is required.");
      }

      if (!String(this.projectAddress ?? '').trim()) {
        errors.push("End User/Customer Street Address is required.");
      }

      if (!String(this.projectCity ?? '').trim()) {
        errors.push("End User/Customer City is required.");
      }

      if (!String(this.projectState ?? '').trim()) {
        errors.push("End User/Customer State is required.");
      }

      if (!String(this.projectZip ?? '').trim()) {
        errors.push("End User/Customer Zip Code is required.");
      }

      /* COntact */

      if (!String(this.contactName ?? '').trim()) {
        errors.push("Contact Name is required.");
      }
      if (!String(this.contactPhone ?? '').trim()) {
        errors.push("Contact Phone is required.");
      }
      if (!String(this.contactEmail ?? '').trim()) {
        errors.push("Contact Email is required.");
      }

      console.log(errors)

      return {
        isValid: errors.length === 0,
        errors,
      };
    },
    validateAndShow() {
      const { isValid, errors } = this.validate();

      if (isValid) {
        this.submitProject()
        // alert("it's good!")
        return;
      }
      // Show up to ~5 individual toasts, then a summary
      if (errors.length <= 5) {
        errors.forEach((err) => {
          this.$toast.error(err);
        });
      } else {
        errors.slice(0, 3).forEach(err => this.$toast.error(err));
      }
    },
  },
  computed: {
    filteredReps() {
      if (!this.acFilter) {
        return this.salespeople
      }

      return this.salespeople.filter(user => 
        user.acid === Number(this.acFilter.acid)
      )
    },
    activeNav() {
      return this.$store.state.activePage;
    },
    colorGetter() {
      return this.$store.state.colors;
    },
     checkFirst: function(){
       if(this.contactName.length){
         let fullName = this.contactName.split(' ');
         return fullName[0]
       } else {
         return '';
       }
    },

    checkLast: function(){
       if(this.contactName.length){
         let fullName = this.contactName.split(' ');
         return fullName[1]
       } else {
         return '';
       }
    },



    companyID() {
      let number = this.$store.state.user.ACId[0];
      this.acid = number;
    },
    states() {
      return new Set(this.acList.map((x) => x.State).sort());
    },
  },
  created() {
    this.$store.commit("showNavigation");
    // console.log(this.$route.path);
  },
  mounted() {
    this.firstLoad();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#pickDate1 input {
  border: 0 !important;
  outline: none !important;
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #00b4b4;
  border-color: #00b4b4;
}

.leadTime {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}
.top-wrap {
  display: flex;
  align-items: flex-start;
}
.leadTime-bottom {
  align-items: flex-end;
}
.leadTime-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}
.small-lh {
  line-height: 1.4em;
}

.listing {
  overflow: none;
}

.listing {
  background-color: #fff;
  line-height: 1;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}

.table-responsive {
  display: table;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #e8e8e8 !important;
}
.badge-success {
  color: #fff;
  background-color: #4d5967;
  background-color: #1eb5b6;
}
.table-striped a {
  color: #00b4b4;
}
.table-striped td,
.table-striped th {
  padding: 5px;
  font-weight: 300 !important;
}
.listing {
  border-radius: 4px;
}
table td {
  line-height: 1;
}
.table-striped th {
  background: #00b4b4;
  background: #4d5967;
  color: #fff;
}
.table-striped {
  min-width: 100%;
  overflow: scroll;
}
.search-btns {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  max-height: 40px;
}
.search-btns .clear {
  margin-left: auto;
}
.search-btns .search {
  margin-left: 5px;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}

@media all and (min-width: 768px) {
  .dates {
    display: flex;
    color: #757575 !important;
  }
}
.top-search {
  color: #757575;
}
select.form-control:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575;
}
.all-contractors {
  color: #757575 !important;
}
.header-divide {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}
.table-striped td:last-of-type {
  text-align: right;
}
.table-striped th:last-of-type {
  text-align: right;
}
.table-bordered td:first-of-type {
  border-right: none !important;
}
.table-bordered th:first-of-type {
  border-right: none !important;
}
.table-bordered td:last-of-type {
  border-left: none !important;
}
.table-bordered th:last-of-type {
  border-left: none !important;
}
.m50 {
  margin: 50px 0;
}
.nav-btns {
  display: flex;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
.listing-header {
  background: #fff;
  color: #575757;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}
.loader {
  margin: 0 auto 20px;
  width: 100%;
  height: 25px;
  border-radius: 14px;
  border-bottom: 1px solid #fff;
  border-top: 1px solid #999;
  background: #ccc;
  overflow: hidden;
  position: relative;
}

.progress-bar {
  height: inherit;
  width: 0%;
  border-radius: inherit;
  position: relative;
  overflow: hidden;
}

.progress-stripes {
  width: inherit;
  height: inherit;
  font-size: 180px;
  font-weight: bold;
  margin-top: -50px;
  letter-spacing: -14px;
}

.percentage {
  position: absolute;
  top: 0;
  right: 5px;
  font-weight: bold;
  font-size: 16px;
}
/* PURPLE */
.teal .progress-bar {
  background: #00bcbc;
}
.teal .progress-stripes {
  color: #00b4b4;
}
.teal .percentage {
  color: #eee;
}
.first-step {
  width: 20%;
}
.second-step {
  width: 60%;
}
.third-step {
  width: 90%;
}
.fourth-step {
  width: 100%;
}
.fifth-step {
  width: 90%;
}
.teal {
  color: #00b4b4;
}
.lookup-wrapper {
  text-align: center;
}
.lookup-svg {
  width: 300px;
  height: auto;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
  margin-right: auto;
  margin: 0 auto;
}
.show-all-btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: rgb(124, 124, 129);

  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 20px;
}
.show-all-btn:hover {
  background: #4d5967;
}
.custom-control-label:before {
  background-color: #dedede;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #00b4b4 !important;
}
input:focus {
  border-color: #00BCBC;
}
textarea:focus {
  border-color: #00BCBC;
}
</style>
<style>
.style-chooser .vs__selected{
      background-color: #00BCBC!important;
      color: #fff!important;
}
.style-chooser .vs__dropdown-option--highlight{
    background-color: #00BCBC!important;
    color: #fff!important;
}
.style-chooser .vs__selected-options{
  padding: 10px;
}
.style-chooser .vs__dropdown-option .vs__dropdown-option--highlight{
  background-color: #00BCBC!important;
  color: #fff!important;
}
.style-chooser .vs__deselect{
  fill: #fff;
}
.style-chooser .vs__selected{
  border: none;
  font-weight: 300;
  padding: 2px 10px;
}
.style-chooser .vs__dropdown-toggle{
  padding: 0;
}
.style-chooser .vs__search{
  margin: 0;
  padding: 0;
}

element.style {
}
.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
textarea {
    overflow: auto;
    resize: vertical;
}
button, input, optgroup, select, textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}
*, ::after, ::before {
    box-sizing: border-box;
}
user agent stylesheet
textarea {
    box-sizing: border-box;
}
.success-header{
  background: #00b4b4;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  padding: 50px;
}
.success-header img{
    max-width: 200px;
    
}
.failure-header{
  background: #00b4b4;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  padding: 50px;
}
.failure-header img{
    width: 200px;
    
}
.success-body{
  text-align: center;
  padding: 50px;
}
.failure-body{
  text-align: center;
  padding: 50px;
}
.failure-body a{
  color: #00BCBC;
}
.failure-body p {
  margin-bottom: 5px;
}
.orange{
  color:#f16232
}
.custom-radio-group {
  display: flex;
  gap: 1rem; /* space between Yes/No */
}

.custom-radio {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 1rem;
  color: #495057;
  user-select: none;
}

.custom-radio input[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

/* The outer circle */
.custom-radio .radio-dot {
  position: relative;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background: #fff;
  border: 2px solid #ced4da; /* default unchecked border */
  border-radius: 50%;
  transition: all 0.2s ease;
}

/* Checked state */
.custom-radio input[type="radio"]:checked + .radio-dot {
  border-color: #00b4b4;
}

/* Inner filled dot when checked */
.custom-radio .radio-dot::after {
  content: '';
  position: absolute;
  top: 4px;
  left: 4px;
  width: 8px;
  height: 8px;
  background: #00b4b4;
  border-radius: 50%;
  opacity: 0;
  transform: scale(0);
  transition: all 0.2s ease;
}

.custom-radio input[type="radio"]:checked + .radio-dot::after {
  opacity: 1;
  transform: scale(1);
}

/* Hover effect */
.custom-radio:hover .radio-dot {
  border-color: #00b4b4;
}

/* Focus state for all .form-control elements (inputs, selects, textareas) */
.form-control:focus {
  border-color: #00b4b4 !important;

  outline: none;  /* removes any default browser outline */
}

/* Optional: stronger hover/focus for selects specifically */
select.form-control:focus {
  border-color: #00b4b4 !important;

}

/* Optional: make the border slightly thicker or change on hover too */
.form-control:hover {
  border-color: #009999;  /* darker teal on hover (subtle feedback) */
}
.v-toast__item {
    opacity: 1;
    min-height: 40px!important;
}
.v-toast__text {
    opacity: 1;
    min-height: 40px!important;
}
.v-toast__item .v-toast__text {
    padding: 10px 20px!important;
}
.v-toast__item--error {
    background-color: #b40000;
}
.v-toast__item--success {
    background-color: #00b4b4;
}
.v-toast__item .v-toast__icon {
    display: block;
    width: 20px!important;
    min-width: 20px!important;
    height: 20px!important;
    margin-left: 20px!important;
}

.pixelsbghex {
  background-color: #475059;
  background-size: cover;
  background-position: center;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200' preserveAspectRatio='xMidYMid slice'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%2356626d'/%3E%3Cstop offset='1' stop-color='%2356626d' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%2337778a'/%3E%3Cstop offset='1' stop-color='%2337778a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%232b5c60'/%3E%3Cstop offset='1' stop-color='%232b5c60' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23667787'/%3E%3Cstop offset='1' stop-color='%23667787' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3ClinearGradient id='base' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='.5' stop-color='%2356626d'/%3E%3Cstop offset='1' stop-color='%231a8182'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect fill='%23475059' width='1950' height='1200'/%3E%3Cpolygon fill='%23454e56' stroke='%23414a52' stroke-width='3' points='0,-180 0,-90 -77.9,-45 -155.9,-90 -155.9,-180 -77.9,-225'/%3E%3Cpolygon fill='%2345525b' stroke='%23404b53' stroke-width='3' points='155.9,-180 155.9,-90 77.9,-45 0,-90 0,-180 77.9,-225'/%3E%3Cpolygon fill='%23475b63' stroke='%233c4f56' stroke-width='3' points='311.8,-180 311.8,-90 233.8,-45 155.9,-90 155.9,-180 233.8,-225'/%3E%3Cpolygon fill='%233d5860' stroke='%23395359' stroke-width='3' points='467.7,-180 467.7,-90 389.7,-45 311.8,-90 311.8,-180 389.7,-225'/%3E%3Cpolygon fill='%233d6067' stroke='%2336565c' stroke-width='3' points='623.5,-180 623.5,-90 545.6,-45 467.7,-90 467.7,-180 545.6,-225'/%3E%3Cpolygon fill='%23355f65' stroke='%23325a5f' stroke-width='3' points='779.4,-180 779.4,-90 701.5,-45 623.5,-90 623.5,-180 701.5,-225'/%3E%3Cpolygon fill='%2333666b' stroke='%232f5d62' stroke-width='3' points='935.3,-180 935.3,-90 857.4,-45 779.4,-90 779.4,-180 857.4,-225'/%3E%3Cpolygon fill='%23366e73' stroke='%232c6165' stroke-width='3' points='1091.2,-180 1091.2,-90 1013.2,-45 935.3,-90 935.3,-180 1013.2,-225'/%3E%3Cpolygon fill='%232b6c70' stroke='%23286568' stroke-width='3' points='1247.1,-180 1247.1,-90 1169.1,-45 1091.2,-90 1091.2,-180 1169.1,-225'/%3E%3Cpolygon fill='%232c7377' stroke='%2325686c' stroke-width='3' points='1403,-180 1403,-90 1325,-45 1247.1,-90 1247.1,-180 1325,-225'/%3E%3Cpolygon fill='%23247275' stroke='%23226c6f' stroke-width='3' points='1558.8,-180 1558.8,-90 1480.9,-45 1403,-90 1403,-180 1480.9,-225'/%3E%3Cpolygon fill='%2321797b' stroke='%231f6f72' stroke-width='3' points='1714.7,-180 1714.7,-90 1636.8,-45 1558.8,-90 1558.8,-180 1636.8,-225'/%3E%3Cpolygon fill='%23248183' stroke='%231b7375' stroke-width='3' points='1870.6,-180 1870.6,-90 1792.7,-45 1714.7,-90 1714.7,-180 1792.7,-225'/%3E%3Cpolygon fill='%231a7f80' stroke='%23187778' stroke-width='3' points='2026.5,-180 2026.5,-90 1948.6,-45 1870.6,-90 1870.6,-180 1948.6,-225'/%3E%3Cpolygon fill='%231d8384' stroke='%23187778' stroke-width='3' points='2182.4,-180 2182.4,-90 2104.4,-45 2026.5,-90 2026.5,-180 2104.4,-225'/%3E%3Cpolygon fill='%234a535b' stroke='%23414a52' stroke-width='3' points='-77.9,-45 -77.9,45 -155.9,90 -233.8,45 -233.8,-45 -155.9,-90'/%3E%3Cpolygon fill='%23454e56' stroke='%23414a52' stroke-width='3' points='77.9,-45 77.9,45 0,90 -77.9,45 -77.9,-45 -0,-90'/%3E%3Cpolygon fill='%2343545c' stroke='%233e4d55' stroke-width='3' points='233.8,-45 233.8,45 155.9,90 77.9,45 77.9,-45 155.9,-90'/%3E%3Cpolygon fill='%23465d64' stroke='%233b5158' stroke-width='3' points='389.7,-45 389.7,45 311.8,90 233.8,45 233.8,-45 311.8,-90'/%3E%3Cpolygon fill='%233b5a61' stroke='%2337545b' stroke-width='3' points='545.6,-45 545.6,45 467.7,90 389.7,45 389.7,-45 467.7,-90'/%3E%3Cpolygon fill='%233c6268' stroke='%2334585e' stroke-width='3' points='701.5,-45 701.5,45 623.5,90 545.6,45 545.6,-45 623.5,-90'/%3E%3Cpolygon fill='%23336166' stroke='%23315c61' stroke-width='3' points='857.4,-45 857.4,45 779.4,90 701.5,45 701.5,-45 779.4,-90'/%3E%3Cpolygon fill='%2331686d' stroke='%232d5f64' stroke-width='3' points='1013.2,-45 1013.2,45 935.3,90 857.4,45 857.4,-45 935.3,-90'/%3E%3Cpolygon fill='%23347074' stroke='%232a6367' stroke-width='3' points='1169.1,-45 1169.1,45 1091.2,90 1013.2,45 1013.2,-45 1091.2,-90'/%3E%3Cpolygon fill='%232a6e71' stroke='%2327666a' stroke-width='3' points='1325,-45 1325,45 1247.1,90 1169.1,45 1169.1,-45 1247.1,-90'/%3E%3Cpolygon fill='%232a7579' stroke='%23246a6d' stroke-width='3' points='1480.9,-45 1480.9,45 1403,90 1325,45 1325,-45 1403,-90'/%3E%3Cpolygon fill='%23227476' stroke='%23206e70' stroke-width='3' points='1636.8,-45 1636.8,45 1558.8,90 1480.9,45 1480.9,-45 1558.8,-90'/%3E%3Cpolygon fill='%231f7b7d' stroke='%231d7173' stroke-width='3' points='1792.7,-45 1792.7,45 1714.7,90 1636.8,45 1636.8,-45 1714.7,-90'/%3E%3Cpolygon fill='%23238384' stroke='%231a7576' stroke-width='3' points='1948.6,-45 1948.6,45 1870.6,90 1792.7,45 1792.7,-45 1870.6,-90'/%3E%3Cpolygon fill='%231a7f80' stroke='%23187778' stroke-width='3' points='2104.4,-45 2104.4,45 2026.5,90 1948.6,45 1948.6,-45 2026.5,-90'/%3E%3Cpolygon fill='%2348515a' stroke='%23434b54' stroke-width='3' points='0,90 0,180 -77.9,225 -155.9,180 -155.9,90 -77.9,45'/%3E%3Cpolygon fill='%234a565f' stroke='%23414d55' stroke-width='3' points='155.9,90 155.9,180 77.9,225 0,180 0,90 77.9,45'/%3E%3Cpolygon fill='%2341555d' stroke='%233e5158' stroke-width='3' points='311.8,90 311.8,180 233.8,225 155.9,180 155.9,90 233.8,45'/%3E%3Cpolygon fill='%23405b63' stroke='%233b545b' stroke-width='3' points='467.7,90 467.7,180 389.7,225 311.8,180 311.8,90 389.7,45'/%3E%3Cpolygon fill='%2342646b' stroke='%2338575e' stroke-width='3' points='623.5,90 623.5,180 545.6,225 467.7,180 467.7,90 545.6,45'/%3E%3Cpolygon fill='%23386168' stroke='%23355b61' stroke-width='3' points='779.4,90 779.4,180 701.5,225 623.5,180 623.5,90 701.5,45'/%3E%3Cpolygon fill='%2339696f' stroke='%23315e64' stroke-width='3' points='935.3,90 935.3,180 857.4,225 779.4,180 779.4,90 857.4,45'/%3E%3Cpolygon fill='%2331676d' stroke='%232e6167' stroke-width='3' points='1091.2,90 1091.2,180 1013.2,225 935.3,180 935.3,90 1013.2,45'/%3E%3Cpolygon fill='%232f6e73' stroke='%232b656a' stroke-width='3' points='1247.1,90 1247.1,180 1169.1,225 1091.2,180 1091.2,90 1169.1,45'/%3E%3Cpolygon fill='%2332757a' stroke='%2328686d' stroke-width='3' points='1403,90 1403,180 1325,225 1247.1,180 1247.1,90 1325,45'/%3E%3Cpolygon fill='%23277378' stroke='%23256b70' stroke-width='3' points='1558.8,90 1558.8,180 1480.9,225 1403,180 1403,90 1480.9,45'/%3E%3Cpolygon fill='%23287b7e' stroke='%23216f73' stroke-width='3' points='1714.7,90 1714.7,180 1636.8,225 1558.8,180 1558.8,90 1636.8,45'/%3E%3Cpolygon fill='%2320787c' stroke='%231e7275' stroke-width='3' points='1870.6,90 1870.6,180 1792.7,225 1714.7,180 1714.7,90 1792.7,45'/%3E%3Cpolygon fill='%231d8083' stroke='%231b7678' stroke-width='3' points='2026.5,90 2026.5,180 1948.6,225 1870.6,180 1870.6,90 1948.6,45'/%3E%3Cpolygon fill='%23248487' stroke='%231b7678' stroke-width='3' points='2182.4,90 2182.4,180 2104.4,225 2026.5,180 2026.5,90 2104.4,45'/%3E%3Cpolygon fill='%23505962' stroke='%23444d56' stroke-width='3' points='-77.9,225 -77.9,315 -155.9,360 -233.8,315 -233.8,225 -155.9,180'/%3E%3Cpolygon fill='%2349535c' stroke='%23444d56' stroke-width='3' points='77.9,225 77.9,315 0,360 -77.9,315 -77.9,225 -0,180'/%3E%3Cpolygon fill='%234a5a63' stroke='%23415159' stroke-width='3' points='233.8,225 233.8,315 155.9,360 77.9,315 77.9,225 155.9,180'/%3E%3Cpolygon fill='%23425861' stroke='%233e545c' stroke-width='3' points='389.7,225 389.7,315 311.8,360 233.8,315 233.8,225 311.8,180'/%3E%3Cpolygon fill='%23415e67' stroke='%233b575f' stroke-width='3' points='545.6,225 545.6,315 467.7,360 389.7,315 389.7,225 467.7,180'/%3E%3Cpolygon fill='%2343676e' stroke='%23385a62' stroke-width='3' points='701.5,225 701.5,315 623.5,360 545.6,315 545.6,225 623.5,180'/%3E%3Cpolygon fill='%2339646b' stroke='%23365d64' stroke-width='3' points='857.4,225 857.4,315 779.4,360 701.5,315 701.5,225 779.4,180'/%3E%3Cpolygon fill='%233a6b72' stroke='%23336067' stroke-width='3' points='1013.2,225 1013.2,315 935.3,360 857.4,315 857.4,225 935.3,180'/%3E%3Cpolygon fill='%23326970' stroke='%232f636a' stroke-width='3' points='1169.1,225 1169.1,315 1091.2,360 1013.2,315 1013.2,225 1091.2,180'/%3E%3Cpolygon fill='%23306f76' stroke='%232c676d' stroke-width='3' points='1325,225 1325,315 1247.1,360 1169.1,315 1169.1,225 1247.1,180'/%3E%3Cpolygon fill='%2333777d' stroke='%23296a6f' stroke-width='3' points='1480.9,225 1480.9,315 1403,360 1325,315 1325,225 1403,180'/%3E%3Cpolygon fill='%2329747a' stroke='%23266d72' stroke-width='3' points='1636.8,225 1636.8,315 1558.8,360 1480.9,315 1480.9,225 1558.8,180'/%3E%3Cpolygon fill='%23297c81' stroke='%23237075' stroke-width='3' points='1792.7,225 1792.7,315 1714.7,360 1636.8,315 1636.8,225 1714.7,180'/%3E%3Cpolygon fill='%2321797e' stroke='%23207378' stroke-width='3' points='1948.6,225 1948.6,315 1870.6,360 1792.7,315 1792.7,225 1870.6,180'/%3E%3Cpolygon fill='%23217f84' stroke='%231e7579' stroke-width='3' points='2104.4,225 2104.4,315 2026.5,360 1948.6,315 1948.6,225 2026.5,180'/%3E%3Cpolygon fill='%234c5660' stroke='%23464f58' stroke-width='3' points='0,360 0,450 -77.9,495 -155.9,450 -155.9,360 -77.9,315'/%3E%3Cpolygon fill='%23505d66' stroke='%2345515a' stroke-width='3' points='155.9,360 155.9,450 77.9,495 0,450 0,360 77.9,315'/%3E%3Cpolygon fill='%23465a63' stroke='%2342545d' stroke-width='3' points='311.8,360 311.8,450 233.8,495 155.9,450 155.9,360 233.8,315'/%3E%3Cpolygon fill='%2348616a' stroke='%233f575f' stroke-width='3' points='467.7,360 467.7,450 389.7,495 311.8,450 311.8,360 389.7,315'/%3E%3Cpolygon fill='%23405f68' stroke='%233d5a62' stroke-width='3' points='623.5,360 623.5,450 545.6,495 467.7,450 467.7,360 545.6,315'/%3E%3Cpolygon fill='%233f656e' stroke='%233a5d65' stroke-width='3' points='779.4,360 779.4,450 701.5,495 623.5,450 623.5,360 701.5,315'/%3E%3Cpolygon fill='%23436d75' stroke='%23386068' stroke-width='3' points='935.3,360 935.3,450 857.4,495 779.4,450 779.4,360 857.4,315'/%3E%3Cpolygon fill='%23396a72' stroke='%2335636b' stroke-width='3' points='1091.2,360 1091.2,450 1013.2,495 935.3,450 935.3,360 1013.2,315'/%3E%3Cpolygon fill='%23397079' stroke='%2332656d' stroke-width='3' points='1247.1,360 1247.1,450 1169.1,495 1091.2,450 1091.2,360 1169.1,315'/%3E%3Cpolygon fill='%23316e76' stroke='%232e6870' stroke-width='3' points='1403,360 1403,450 1325,495 1247.1,450 1247.1,360 1325,315'/%3E%3Cpolygon fill='%232f747c' stroke='%232b6b72' stroke-width='3' points='1558.8,360 1558.8,450 1480.9,495 1403,450 1403,360 1480.9,315'/%3E%3Cpolygon fill='%23317b83' stroke='%23276e75' stroke-width='3' points='1714.7,360 1714.7,450 1636.8,495 1558.8,450 1558.8,360 1636.8,315'/%3E%3Cpolygon fill='%23277980' stroke='%23247177' stroke-width='3' points='1870.6,360 1870.6,450 1792.7,495 1714.7,450 1714.7,360 1792.7,315'/%3E%3Cpolygon fill='%23278087' stroke='%2321747a' stroke-width='3' points='2026.5,360 2026.5,450 1948.6,495 1870.6,450 1870.6,360 1948.6,315'/%3E%3Cpolygon fill='%23237a81' stroke='%2321747a' stroke-width='3' points='2182.4,360 2182.4,450 2104.4,495 2026.5,450 2026.5,360 2104.4,315'/%3E%3Cpolygon fill='%234b565f' stroke='%2348515a' stroke-width='3' points='-77.9,495 -77.9,585 -155.9,630 -233.8,585 -233.8,495 -155.9,450'/%3E%3Cpolygon fill='%234e5862' stroke='%2348515a' stroke-width='3' points='77.9,495 77.9,585 0,630 -77.9,585 -77.9,495 -0,450'/%3E%3Cpolygon fill='%2351616a' stroke='%2345545e' stroke-width='3' points='233.8,495 233.8,585 155.9,630 77.9,585 77.9,495 155.9,450'/%3E%3Cpolygon fill='%23485e68' stroke='%23435861' stroke-width='3' points='389.7,495 389.7,585 311.8,630 233.8,585 233.8,495 311.8,450'/%3E%3Cpolygon fill='%234a656f' stroke='%23425b64' stroke-width='3' points='545.6,495 545.6,585 467.7,630 389.7,585 389.7,495 467.7,450'/%3E%3Cpolygon fill='%2344636d' stroke='%23405e68' stroke-width='3' points='701.5,495 701.5,585 623.5,630 545.6,585 545.6,495 623.5,450'/%3E%3Cpolygon fill='%23456974' stroke='%233f616b' stroke-width='3' points='857.4,495 857.4,585 779.4,630 701.5,585 701.5,495 779.4,450'/%3E%3Cpolygon fill='%2348707b' stroke='%233d636d' stroke-width='3' points='1013.2,495 1013.2,585 935.3,630 857.4,585 857.4,495 935.3,450'/%3E%3Cpolygon fill='%233f6d77' stroke='%233b656f' stroke-width='3' points='1169.1,495 1169.1,585 1091.2,630 1013.2,585 1013.2,495 1091.2,450'/%3E%3Cpolygon fill='%233e727d' stroke='%23376771' stroke-width='3' points='1325,495 1325,585 1247.1,630 1169.1,585 1169.1,495 1247.1,450'/%3E%3Cpolygon fill='%23356f79' stroke='%23326a73' stroke-width='3' points='1480.9,495 1480.9,585 1403,630 1325,585 1325,495 1403,450'/%3E%3Cpolygon fill='%2331757f' stroke='%232e6c75' stroke-width='3' points='1636.8,495 1636.8,585 1558.8,630 1480.9,585 1480.9,495 1558.8,450'/%3E%3Cpolygon fill='%23337c85' stroke='%23296e77' stroke-width='3' points='1792.7,495 1792.7,585 1714.7,630 1636.8,585 1636.8,495 1714.7,450'/%3E%3Cpolygon fill='%23297982' stroke='%2326717a' stroke-width='3' points='1948.6,495 1948.6,585 1870.6,630 1792.7,585 1792.7,495 1870.6,450'/%3E%3Cpolygon fill='%232a7e87' stroke='%2324737b' stroke-width='3' points='2104.4,495 2104.4,585 2026.5,630 1948.6,585 1948.6,495 2026.5,450'/%3E%3Cpolygon fill='%23525d67' stroke='%2349535d' stroke-width='3' points='0,630 0,720 -77.9,765 -155.9,720 -155.9,630 -77.9,585'/%3E%3Cpolygon fill='%234c5a64' stroke='%2348555f' stroke-width='3' points='155.9,630 155.9,720 77.9,765 0,720 0,630 77.9,585'/%3E%3Cpolygon fill='%234d606b' stroke='%23475862' stroke-width='3' points='311.8,630 311.8,720 233.8,765 155.9,720 155.9,630 233.8,585'/%3E%3Cpolygon fill='%23526974' stroke='%23465c66' stroke-width='3' points='467.7,630 467.7,720 389.7,765 311.8,720 311.8,630 389.7,585'/%3E%3Cpolygon fill='%234c6772' stroke='%2347606b' stroke-width='3' points='623.5,630 623.5,720 545.6,765 467.7,720 467.7,630 545.6,585'/%3E%3Cpolygon fill='%23516e7a' stroke='%2348636f' stroke-width='3' points='779.4,630 779.4,720 701.5,765 623.5,720 623.5,630 701.5,585'/%3E%3Cpolygon fill='%234d6b78' stroke='%23496671' stroke-width='3' points='935.3,630 935.3,720 857.4,765 779.4,720 779.4,630 857.4,585'/%3E%3Cpolygon fill='%234d707d' stroke='%23476773' stroke-width='3' points='1091.2,630 1091.2,720 1013.2,765 935.3,720 935.3,630 1013.2,585'/%3E%3Cpolygon fill='%234e7582' stroke='%23436874' stroke-width='3' points='1247.1,630 1247.1,720 1169.1,765 1091.2,720 1091.2,630 1169.1,585'/%3E%3Cpolygon fill='%2341717c' stroke='%233d6974' stroke-width='3' points='1403,630 1403,720 1325,765 1247.1,720 1247.1,630 1325,585'/%3E%3Cpolygon fill='%233e7682' stroke='%23366b75' stroke-width='3' points='1558.8,630 1558.8,720 1480.9,765 1403,720 1403,630 1480.9,585'/%3E%3Cpolygon fill='%2333737e' stroke='%23306d77' stroke-width='3' points='1714.7,630 1714.7,720 1636.8,765 1558.8,720 1558.8,630 1636.8,585'/%3E%3Cpolygon fill='%232f7984' stroke='%232c6f79' stroke-width='3' points='1870.6,630 1870.6,720 1792.7,765 1714.7,720 1714.7,630 1792.7,585'/%3E%3Cpolygon fill='%23317f8a' stroke='%2328717c' stroke-width='3' points='2026.5,630 2026.5,720 1948.6,765 1870.6,720 1870.6,630 1948.6,585'/%3E%3Cpolygon fill='%232a7a84' stroke='%2327717c' stroke-width='3' points='2182.4,630 2182.4,720 2104.4,765 2026.5,720 2026.5,630 2104.4,585'/%3E%3Cpolygon fill='%23505b65' stroke='%234b555f' stroke-width='3' points='-77.9,765 -77.9,855 -155.9,900 -233.8,855 -233.8,765 -155.9,720'/%3E%3Cpolygon fill='%2354606a' stroke='%234b565f' stroke-width='3' points='77.9,765 77.9,855 0,900 -77.9,855 -77.9,765 -0,720'/%3E%3Cpolygon fill='%234e5e69' stroke='%234a5963' stroke-width='3' points='233.8,765 233.8,855 155.9,900 77.9,855 77.9,765 155.9,720'/%3E%3Cpolygon fill='%23506571' stroke='%234a5d68' stroke-width='3' points='389.7,765 389.7,855 311.8,900 233.8,855 233.8,765 311.8,720'/%3E%3Cpolygon fill='%23586e7b' stroke='%234c616d' stroke-width='3' points='545.6,765 545.6,855 467.7,900 389.7,855 389.7,765 467.7,720'/%3E%3Cpolygon fill='%23556d7a' stroke='%234f6672' stroke-width='3' points='701.5,765 701.5,855 623.5,900 545.6,855 545.6,765 623.5,720'/%3E%3Cpolygon fill='%235c7482' stroke='%23526976' stroke-width='3' points='857.4,765 857.4,855 779.4,900 701.5,855 701.5,765 779.4,720'/%3E%3Cpolygon fill='%2358707e' stroke='%23536a78' stroke-width='3' points='1013.2,765 1013.2,855 935.3,900 857.4,855 857.4,765 935.3,720'/%3E%3Cpolygon fill='%23577382' stroke='%23506a78' stroke-width='3' points='1169.1,765 1169.1,855 1091.2,900 1013.2,855 1013.2,765 1091.2,720'/%3E%3Cpolygon fill='%23567785' stroke='%234a6a77' stroke-width='3' points='1325,765 1325,855 1247.1,900 1169.1,855 1169.1,765 1247.1,720'/%3E%3Cpolygon fill='%2346727f' stroke='%23416a77' stroke-width='3' points='1480.9,765 1480.9,855 1403,900 1325,855 1325,765 1403,720'/%3E%3Cpolygon fill='%23417784' stroke='%23396b78' stroke-width='3' points='1636.8,765 1636.8,855 1558.8,900 1480.9,855 1480.9,765 1558.8,720'/%3E%3Cpolygon fill='%23357380' stroke='%23326d79' stroke-width='3' points='1792.7,765 1792.7,855 1714.7,900 1636.8,855 1636.8,765 1714.7,720'/%3E%3Cpolygon fill='%23317986' stroke='%232d6f7b' stroke-width='3' points='1948.6,765 1948.6,855 1870.6,900 1792.7,855 1792.7,765 1870.6,720'/%3E%3Cpolygon fill='%23357e8b' stroke='%232b707d' stroke-width='3' points='2104.4,765 2104.4,855 2026.5,900 1948.6,855 1948.6,765 2026.5,720'/%3E%3Cpolygon fill='%2358646e' stroke='%234d5761' stroke-width='3' points='0,900 0,990 -77.9,1035 -155.9,990 -155.9,900 -77.9,855'/%3E%3Cpolygon fill='%2352606a' stroke='%234c5963' stroke-width='3' points='155.9,900 155.9,990 77.9,1035 0,990 0,900 77.9,855'/%3E%3Cpolygon fill='%23556773' stroke='%234c5d68' stroke-width='3' points='311.8,900 311.8,990 233.8,1035 155.9,990 155.9,900 233.8,855'/%3E%3Cpolygon fill='%23526673' stroke='%234d616d' stroke-width='3' points='467.7,900 467.7,990 389.7,1035 311.8,990 311.8,900 389.7,855'/%3E%3Cpolygon fill='%23586f7c' stroke='%23516673' stroke-width='3' points='623.5,900 623.5,990 545.6,1035 467.7,990 467.7,900 545.6,855'/%3E%3Cpolygon fill='%23627785' stroke='%23556977' stroke-width='3' points='779.4,900 779.4,990 701.5,1035 623.5,990 623.5,900 701.5,855'/%3E%3Cpolygon fill='%235f7382' stroke='%23596b7a' stroke-width='3' points='935.3,900 935.3,990 857.4,1035 779.4,990 779.4,900 857.4,855'/%3E%3Cpolygon fill='%23627787' stroke='%23586c7a' stroke-width='3' points='1091.2,900 1091.2,990 1013.2,1035 935.3,990 935.3,900 1013.2,855'/%3E%3Cpolygon fill='%23587180' stroke='%23536b79' stroke-width='3' points='1247.1,900 1247.1,990 1169.1,1035 1091.2,990 1091.2,900 1169.1,855'/%3E%3Cpolygon fill='%23517483' stroke='%234b6b78' stroke-width='3' points='1403,900 1403,990 1325,1035 1247.1,990 1247.1,900 1325,855'/%3E%3Cpolygon fill='%234d7886' stroke='%23416b78' stroke-width='3' points='1558.8,900 1558.8,990 1480.9,1035 1403,990 1403,900 1480.9,855'/%3E%3Cpolygon fill='%233d7382' stroke='%23396c79' stroke-width='3' points='1714.7,900 1714.7,990 1636.8,1035 1558.8,990 1558.8,900 1636.8,855'/%3E%3Cpolygon fill='%233a7988' stroke='%23336d7b' stroke-width='3' points='1870.6,900 1870.6,990 1792.7,1035 1714.7,990 1714.7,900 1792.7,855'/%3E%3Cpolygon fill='%23317584' stroke='%232e6f7d' stroke-width='3' points='2026.5,900 2026.5,990 1948.6,1035 1870.6,990 1870.6,900 1948.6,855'/%3E%3Cpolygon fill='%23317988' stroke='%232d6f7d' stroke-width='3' points='2182.4,900 2182.4,990 2104.4,1035 2026.5,990 2026.5,900 2104.4,855'/%3E%3Cpolygon fill='%2355616b' stroke='%234e5963' stroke-width='3' points='-77.9,1035 -77.9,1125 -155.9,1170 -233.8,1125 -233.8,1035 -155.9,990'/%3E%3Cpolygon fill='%235a6671' stroke='%234e5963' stroke-width='3' points='77.9,1035 77.9,1125 0,1170 -77.9,1125 -77.9,1035 -0,990'/%3E%3Cpolygon fill='%2353636e' stroke='%234d5c67' stroke-width='3' points='233.8,1035 233.8,1125 155.9,1170 77.9,1125 77.9,1035 155.9,990'/%3E%3Cpolygon fill='%23566a77' stroke='%234d606b' stroke-width='3' points='389.7,1035 389.7,1125 311.8,1170 233.8,1125 233.8,1035 311.8,990'/%3E%3Cpolygon fill='%23536976' stroke='%234f6370' stroke-width='3' points='545.6,1035 545.6,1125 467.7,1170 389.7,1125 389.7,1035 467.7,990'/%3E%3Cpolygon fill='%2359707f' stroke='%23526774' stroke-width='3' points='701.5,1035 701.5,1125 623.5,1170 545.6,1125 545.6,1035 623.5,990'/%3E%3Cpolygon fill='%23617786' stroke='%23556a78' stroke-width='3' points='857.4,1035 857.4,1125 779.4,1170 701.5,1125 701.5,1035 779.4,990'/%3E%3Cpolygon fill='%235c7282' stroke='%23566b79' stroke-width='3' points='1013.2,1035 1013.2,1125 935.3,1170 857.4,1125 857.4,1035 935.3,990'/%3E%3Cpolygon fill='%235d7685' stroke='%23546b79' stroke-width='3' points='1169.1,1035 1169.1,1125 1091.2,1170 1013.2,1125 1013.2,1035 1091.2,990'/%3E%3Cpolygon fill='%2352707f' stroke='%234e6a79' stroke-width='3' points='1325,1035 1325,1125 1247.1,1170 1169.1,1125 1169.1,1035 1247.1,990'/%3E%3Cpolygon fill='%234c7383' stroke='%23466a79' stroke-width='3' points='1480.9,1035 1480.9,1125 1403,1170 1325,1125 1325,1035 1403,990'/%3E%3Cpolygon fill='%23497888' stroke='%233e6b79' stroke-width='3' points='1636.8,1035 1636.8,1125 1558.8,1170 1480.9,1125 1480.9,1035 1558.8,990'/%3E%3Cpolygon fill='%233c7484' stroke='%23386c7b' stroke-width='3' points='1792.7,1035 1792.7,1125 1714.7,1170 1636.8,1125 1636.8,1035 1714.7,990'/%3E%3Cpolygon fill='%233a798a' stroke='%23336e7d' stroke-width='3' points='1948.6,1035 1948.6,1125 1870.6,1170 1792.7,1125 1792.7,1035 1870.6,990'/%3E%3Cpolygon fill='%23337485' stroke='%23316e7e' stroke-width='3' points='2104.4,1035 2104.4,1125 2026.5,1170 1948.6,1125 1948.6,1035 2026.5,990'/%3E%3Cpolygon fill='%23545f6a' stroke='%234f5a65' stroke-width='3' points='0,1170 0,1260 -77.9,1305 -155.9,1260 -155.9,1170 -77.9,1125'/%3E%3Cpolygon fill='%2355646f' stroke='%234f5c66' stroke-width='3' points='155.9,1170 155.9,1260 77.9,1305 0,1260 0,1170 77.9,1125'/%3E%3Cpolygon fill='%23596b77' stroke='%234d5e69' stroke-width='3' points='311.8,1170 311.8,1260 233.8,1305 155.9,1260 155.9,1170 233.8,1125'/%3E%3Cpolygon fill='%23526875' stroke='%234d616d' stroke-width='3' points='467.7,1170 467.7,1260 389.7,1305 311.8,1260 311.8,1170 389.7,1125'/%3E%3Cpolygon fill='%23576e7c' stroke='%234e6470' stroke-width='3' points='623.5,1170 623.5,1260 545.6,1305 467.7,1260 467.7,1170 545.6,1125'/%3E%3Cpolygon fill='%23536c7a' stroke='%234f6674' stroke-width='3' points='779.4,1170 779.4,1260 701.5,1305 623.5,1260 623.5,1170 701.5,1125'/%3E%3Cpolygon fill='%23567180' stroke='%234f6876' stroke-width='3' points='935.3,1170 935.3,1260 857.4,1305 779.4,1260 779.4,1170 857.4,1125'/%3E%3Cpolygon fill='%235a7685' stroke='%234e6977' stroke-width='3' points='1091.2,1170 1091.2,1260 1013.2,1305 935.3,1260 935.3,1170 1013.2,1125'/%3E%3Cpolygon fill='%23507080' stroke='%234b6977' stroke-width='3' points='1247.1,1170 1247.1,1260 1169.1,1305 1091.2,1260 1091.2,1170 1169.1,1125'/%3E%3Cpolygon fill='%234e7484' stroke='%23466978' stroke-width='3' points='1403,1170 1403,1260 1325,1305 1247.1,1260 1247.1,1170 1325,1125'/%3E%3Cpolygon fill='%23436f80' stroke='%23406a79' stroke-width='3' points='1558.8,1170 1558.8,1260 1480.9,1305 1403,1260 1403,1170 1480.9,1125'/%3E%3Cpolygon fill='%23407485' stroke='%233b6b7b' stroke-width='3' points='1714.7,1170 1714.7,1260 1636.8,1305 1558.8,1260 1558.8,1170 1636.8,1125'/%3E%3Cpolygon fill='%23417a8b' stroke='%23376c7d' stroke-width='3' points='1870.6,1170 1870.6,1260 1792.7,1305 1714.7,1260 1714.7,1170 1792.7,1125'/%3E%3Cpolygon fill='%23377588' stroke='%23336d7f' stroke-width='3' points='2026.5,1170 2026.5,1260 1948.6,1305 1870.6,1260 1870.6,1170 1948.6,1125'/%3E%3Cpolygon fill='%233a798c' stroke='%23336d7f' stroke-width='3' points='2182.4,1170 2182.4,1260 2104.4,1305 2026.5,1260 2026.5,1170 2104.4,1125'/%3E%3Cg fill-opacity='0.6'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
}

</style>
